import logo1 from "@/assets/kunde-videoproduktion-aachen-1.png";
import logo2 from "@/assets/kunde-videoproduktion-aachen-2.png";
import logo3 from "@/assets/kunde-videoproduktion-aachen-3.png";
import logo4 from "@/assets/kunde-imagefilm-aachen-4.webp";
import logo5 from "@/assets/kunde-imagefilm-aachen-5.webp";
import logo6 from "@/assets/kunde-imagefilm-aachen-6.webp";

const BrandLogos = () => {
  const logos = [
    { src: logo1, alt: "Kunde Videoproduktion Aachen - Referenz 1" },
    { src: logo2, alt: "Kunde Videoproduktion Aachen - Referenz 2" },
    { src: logo3, alt: "Kunde Imagefilm Aachen - Referenz 3" },
    { src: logo4, alt: "Kunde Imagefilm Aachen - Referenz 4" },
    { src: logo5, alt: "Videoagentur Aachen - Kunde 5" },
    { src: logo6, alt: "Videoagentur Aachen - Kunde 6" },
  ];

  return (
    <section className="py-4 md:py-8 bg-gradient-to-b from-black via-background/50 to-background/80 relative overflow-hidden">
      <div className="container mx-auto px-4 md:px-8 max-w-7xl">
        <div className="relative w-full overflow-hidden rounded-2xl">
        {/* Edge Fade Masks */}
        <div className="absolute left-0 top-0 bottom-0 w-32 md:w-48 bg-gradient-to-r from-background to-transparent z-10 pointer-events-none"></div>
        <div className="absolute right-0 top-0 bottom-0 w-32 md:w-48 bg-gradient-to-l from-background to-transparent z-10 pointer-events-none"></div>
        
        {/* Infinite Scrolling Banner */}
        <div className="flex animate-scroll hover:[animation-play-state:paused]">
        {/* First set of logos */}
        {logos.map((logo, index) => (
          <div
            key={`first-${index}`}
            className="flex-shrink-0 mx-8 md:mx-16 flex items-center justify-center"
          >
            <img
              src={logo.src}
              alt={logo.alt}
              loading="lazy"
              decoding="async"
              width="120"
              height="48"
              className="h-12 md:h-16 w-auto object-contain opacity-40 hover:opacity-80 transition-opacity duration-300 grayscale hover:grayscale-0"
            />
          </div>
        ))}
        {/* Duplicate set for seamless loop */}
        {logos.map((logo, index) => (
          <div
            key={`second-${index}`}
            className="flex-shrink-0 mx-8 md:mx-16 flex items-center justify-center"
          >
            <img
              src={logo.src}
              alt={logo.alt}
              loading="lazy"
              decoding="async"
              width="120"
              height="48"
              className="h-12 md:h-16 w-auto object-contain opacity-40 hover:opacity-80 transition-opacity duration-300 grayscale hover:grayscale-0"
            />
          </div>
        ))}
        {/* Third set for extra smooth looping */}
        {logos.map((logo, index) => (
          <div
            key={`third-${index}`}
            className="flex-shrink-0 mx-8 md:mx-16 flex items-center justify-center"
          >
            <img
              src={logo.src}
              alt={logo.alt}
              loading="lazy"
              decoding="async"
              width="120"
              height="48"
              className="h-12 md:h-16 w-auto object-contain opacity-40 hover:opacity-80 transition-opacity duration-300 grayscale hover:grayscale-0"
            />
          </div>
        ))}
      </div>
        </div>
      </div>
    </section>
  );
};

export default BrandLogos;
